var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEduc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7445",
    "data-name": "Path 7445",
    d: "M57.418,60v8.409A4.9,4.9,0,0,1,54.9,72.691M28,60v8.409A4.9,4.9,0,0,0,30.709,72.8l7.616,3.8a9.806,9.806,0,0,0,8.768,0l5.152-2.57",
    transform: "translate(-16.56 -35.485)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7446",
    "data-name": "Path 7446",
    d: "M12,36.623,33.246,47.246,54.493,36.623,33.246,26Z",
    transform: "translate(-7.097 -15.377)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7447",
    "data-name": "Path 7447",
    d: "M28,41.354,42.709,34l14.709,7.354L42.709,48.709Z",
    transform: "translate(-16.56 -20.108)",
    fill: "none",
    stroke: "#f7901f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 2.5,
    cy: 1,
    rx: 2.5,
    ry: 1,
    transform: "translate(24 20)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7448",
    "data-name": "Path 7448",
    d: "M77.131,66.328V58.565L68.24,54.12",
    transform: "translate(-40.358 -32.007)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7449",
    "data-name": "Path 7449",
    d: "M88.668,93.2l.6,4.817L87.634,97.2,86,98.015l.6-4.825",
    transform: "translate(-50.862 -55.114)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7450",
    "data-name": "Path 7450",
    d: "M89.266,86.272a1.978,1.978,0,0,1-.409,1.3,1.716,1.716,0,0,1-2.451,0,1.978,1.978,0,0,1-.409-1.3C86,85.017,86.728,84,87.631,84S89.266,85.017,89.266,86.272Z",
    transform: "translate(-50.859 -49.679)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7451",
    "data-name": "Path 7451",
    d: "M51.88,91l2.043,1.013a6.578,6.578,0,0,0,5.851,0L61.817,91",
    transform: "translate(-30.683 -53.819)",
    fill: "none",
    stroke: "#f7901f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6893",
    "data-name": "Rectangle 6893",
    width: 52,
    height: 52,
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduc);
export default __webpack_public_path__ + "static/media/educ.57487dee2c8d3035b583f7ac9671c0c8.svg";
export { ForwardRef as ReactComponent };